module.exports = {
  MISSING_CATEGORY_ERROR: 'MissingCategoryError',
  NOT_LOADED_IMAGE_ERROR: 'NotLoadedImageError',
  UNDEFINED_IN_URL_ERROR: 'UndefinedInUrlError',
  JOB_OFFER_404_ERROR: 'JobOffer404Error',
};
